import { render, staticRenderFns } from "./CustomerDataForm.vue?vue&type=template&id=27f01f40&"
import script from "./CustomerDataForm.vue?vue&type=script&lang=js&"
export * from "./CustomerDataForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDataForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports